import { SaveConfirmationModalProps } from './types'
import { Button, Content, StyledModal } from './styles'
import { SaveConfirmationModalHook } from './SaveConfirmationModal.hook'

function SaveConfirmationModal({
  isModalOpen,
  onClose,
  onConfirm,
  isLoading = false,
}: SaveConfirmationModalProps) {
  const { modalContent } = SaveConfirmationModalHook()

  return (
    <StyledModal
      open={isModalOpen}
      closable={false}
      width={350}
      onCancel={onClose}
      centered
      title={modalContent.title}
      footer={[
        <Button key="cancel" onClick={onClose} disabled={isLoading}>
          {modalContent.cancelText}
        </Button>,
        <Button
          key="confirm"
          type="primary"
          onClick={onConfirm}
          loading={isLoading}
          disabled={isLoading}
        >
          {modalContent.confirmText}
        </Button>,
      ]}
    >
      <Content>{modalContent.content}</Content>
    </StyledModal>
  )
}

export default SaveConfirmationModal
